import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { buscarOrdensServico, exportarOrdensServicoExcel } from "./service";

const TAMANHO_PAGINA_PADRAO = 8;

export function useOrdensServico() {
  const [loading, setLoading] = useState(false);
  const [loadingExportExcel, setLoadingExportExcel] = useState(false);

  const [osPendentes, setOsPendentes] = useState([]);
  const [osProcessadas, setOsProcessadas] = useState([]);
  const [totalRegistroPendentes, setTotalRegistroPendentes] = useState(0);
  const [totalRegistroProcessadas, setTotalRegistroProcessadas] = useState(0);

  const [activeTab, setActiveTab] = useState("Pendentes");
  const [page, setPage] = useState(1);
  const [quantidade] = useState(TAMANHO_PAGINA_PADRAO);

  const [idCliente, setIdCliente] = useState("");
  const [tipo, setTipo] = useState("");
  const [situacaoBusca, setSituacaoBusca] = useState("");

  const [msgErrorIdClient] = useState("");

  const [numeroSolicitacao, setNumeroSolicitacao] = useState("");
  const [isModalPortalContadorOS, setIsModalPortalContadorOS] = useState(false);
  const [openModals, setOpenModals] = useState({});

  useEffect(() => {
    const carregarOrdens = async () => {
      setLoading(true);
      try {
        const [pendentes, processadas] = await Promise.all([
          buscarOrdensServico({ situacao: "Pendentes", idCliente, tipo, pagina: page, tamanhoPagina: quantidade }),
          buscarOrdensServico({ situacao: "Processadas", idCliente, tipo, pagina: page, tamanhoPagina: quantidade }),
        ]);

        setOsPendentes(pendentes.lista);
        setTotalRegistroPendentes(pendentes.total);
        setOsProcessadas(processadas.lista);
        setTotalRegistroProcessadas(processadas.total);
      } catch (error) {
        toast.error("Erro ao buscar dados");
      } finally {
        setLoading(false);
      }
    };

    carregarOrdens();
  }, [idCliente, tipo, page, quantidade]);

  const buscarPagina = (novaPagina) => setPage(novaPagina);

  const buscarPorCliente = (idClienteBuscado, situacao, tipoBuscado) => {
    setIdCliente(idClienteBuscado);
    setSituacaoBusca(situacao);
    setTipo(tipoBuscado);
    setPage(1);
  };

  /**
   * Sem argumento: exporta com os filtros de busca correntes (botão "Controle de Planilha").
   * Com situação ("Pendentes"/"Processadas"/"Todos"): exporta o relatório fechado daquela aba.
   */
  const exportarExcel = async (situacaoRelatorio) => {
    setLoadingExportExcel(true);
    try {
      await exportarOrdensServicoExcel({
        idCliente,
        situacao: situacaoRelatorio ?? situacaoBusca,
        tipo: situacaoRelatorio ? "TODOS" : tipo,
      });
    } catch (error) {
      toast.error("Erro ao exportar os dados");
    } finally {
      setLoadingExportExcel(false);
    }
  };

  const abrirTratamento = (idOrdem) => {
    setNumeroSolicitacao(idOrdem);
    setIsModalPortalContadorOS(true);
  };

  const alternarModal = (id) => {
    setOpenModals((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return {
    loading,
    loadingExportExcel,
    osPendentes,
    osProcessadas,
    totalRegistroPendentes,
    totalRegistroProcessadas,
    activeTab,
    setActiveTab,
    page,
    quantidade,
    buscarPagina,
    buscarPorCliente,
    exportarExcel,
    numeroSolicitacao,
    isModalPortalContadorOS,
    setIsModalPortalContadorOS,
    openModals,
    alternarModal,
    abrirTratamento,
    msgErrorIdClient,
  };
}
